<template>
	<div class="animated fadeIn">
		<b-card>
      <h6 slot="header" class="mb-0">OS 타입 선택 - <b-link @click="changeOsType('AOS')">AOS</b-link>  /  <b-link @click="changeOsType('iOS')">iOS</b-link></h6>
      <h4 class="d-inline-block font-weight-bold">{{ osType }} 목록 관리</h4>
      <h5 class="d-inline-block float-right">(총 {{ osType === 'AOS' ? osTypeListData.aos.length : osTypeListData.ios.length }}개)</h5>
      <b-table class="mt-3" hover striped bordered responsive="sm" :items="osTypeList" :fields="fields" :show-empty=true empty-text="리스트가 없습니다." :sort-by="sortBy" :sort-desc="true">
				<template slot="number" slot-scope="data">
					{{ data.index + 1 }}
				</template>
        <template slot="appNameInfo.ko" slot-scope="data">
          <b-link :to="{name: 'playGameEdit', params: { appMasterId: data.item.appMasterId}}">{{ data.item.appNameInfo.ko }}</b-link>
				</template>
				<template slot="appStartTime" slot-scope="data">
					{{ osType ==='AOS' ? data.item.aos.appStartTime.format('YYYY-MM-DD HH:mm') : data.item.ios.appStartTime.format('YYYY-MM-DD HH:mm')}}
				</template>
        <template slot="label" slot-scope="data">
					{{ (osType ==='AOS' ? data.item.aos.viewInfo.iconLabel : data.item.ios.viewInfo.iconLabel) || '-' }}
				</template>
				<template slot="orderTime" slot-scope="data">
					{{ osType ==='AOS' ? data.item.aos.orderTime.format('YYYY-MM-DD HH:mm') : data.item.ios.orderTime.format('YYYY-MM-DD HH:mm') }}
				</template>
			</b-table>
			<nav style="text-align:center">
        <b-button v-if="isMoreData()" @click="showMoreData" variant="outline-primary">더보기▽</b-button>
			</nav>
		</b-card>
	</div>
</template>

<script>
import { MODULE_NAME as PGM_MODULE, FETCT_PLAYGAME_OSTYPE_LIST } from '@/store/playGame/actions.type'
import { $showModalWithErrorMsg } from '@/common/util'
import { SHOW_MODAL } from '@/store/ui/mutations.type'
import { mapGetters, mapMutations } from 'vuex'
import { TABLE_CLASS_WITH_ELLIPSIS, TABLE_DATE_CLASS } from '@/constants'
import playGameService from '@/common/api/playGame.service'
export default {
	data () {
		return {
      osType: 'AOS',
      osTypeList: [],
      osTypeListData: {
        aos: [],
        ios: []
      },
			filteredList: [],
			sortBy: 'orderTime',
			fields: [
				{key: 'number', label: 'No.', class: TABLE_CLASS_WITH_ELLIPSIS, thStyle: 'width: 80px'},
				{key: 'appNameInfo.ko', label: '게임명 (ko)', class: TABLE_CLASS_WITH_ELLIPSIS},
				{key: 'appStartTime', label: 'AOS 출시일', class: TABLE_CLASS_WITH_ELLIPSIS + TABLE_DATE_CLASS},
        {key: 'label', label: '라벨', class: TABLE_CLASS_WITH_ELLIPSIS, thStyle: 'width: 100px'},
        {key: 'orderTime', label: '노출순서 가출시일', class: TABLE_CLASS_WITH_ELLIPSIS + TABLE_DATE_CLASS},
			],
		}
  },
  computed: {
    ...mapGetters(PGM_MODULE, [
      'playGameOsTypeListWithMoment'
    ])
  },
	mounted () {
    this.$store.dispatch(PGM_MODULE + FETCT_PLAYGAME_OSTYPE_LIST)
      .then(() => {
        this.initializeList()
      })
      .catch($showModalWithErrorMsg.bind(this))
  },
  methods: {
    initializeList () {
      this.osTypeListData = this.playGameOsTypeListWithMoment
      this.osTypeList = this.osTypeListData.aos.slice(0, 30)
    },
    changeOsType (type) {
      this.osType = type
      this.fields[2].label = type + '출시일'
      if (!!this.osType.match('AOS')) {
        this.osTypeList = this.osTypeListData.aos.slice(0, 30)
      } else {
        this.osTypeList = this.osTypeListData.ios.slice(0, 30)
      }
    },
    isMoreData () {
      if (!!this.osType.match('AOS')) {
        return this.osTypeListData.aos.length > this.osTypeList.length
      } else {
        return this.osTypeListData.ios.length > this.osTypeList.length
      }
    },
    showMoreData () {
      let len = this.osTypeList.length
      if (!!this.osType.match('AOS')) {
        this.osTypeList = this.osTypeList.concat(this.osTypeListData.aos.slice(len, len + 20))
      } else {
        this.osTypeList = this.osTypeList.concat(this.osTypeListData.ios.slice(len, len + 20))
      }
    },
		...mapMutations('ui', [SHOW_MODAL])
  },
}
</script>
